// frontend/src/services/authService.js
import api from './api';

// 🔐 Email/password register
export const register = async (data) => {
  const res = await api.post('/auth/register', data);
  return res.data;
};

// 🔐 Email/password login
export const login = async (data) => {
  const res = await api.post('/auth/login', data);
  return res.data;
};

// 🔐 Google login
export const googleLogin = async (data) => {
  const res = await api.post('/google', data);
  return res.data;
};

// 🔐 Phone OTP: request
export const requestOtp = async (data) => {
  const res = await api.post('/phone/request-otp', data);
  return res.data;
};

// 🔐 Phone OTP: verify
export const verifyOtp = async (data) => {
  const res = await api.post('/phone/verify-otp', data);
  return res.data;
};

// 🔐 Logout
export const logout = async () => {
  const res = await api.post('/auth/logout');
  return res.data;
};

/* ✅✅ NEW: PROFILE ENDPOINTS */

// GET /api/auth/profile  (authController.getProfile)
export const getProfile = async () => {
  const res = await api.get('/auth/profile');
  return res.data;
};

// PUT /api/auth/profile  (authController.updateProfile)
export const updateProfile = async (payload) => {
  const res = await api.put('/auth/profile', payload);
  return res.data;
};

// 🔐 Forgot Password - Request reset link
export const forgotPassword = async (email) => {
  const res = await api.post('/auth/forgot-password', { email });
  return res.data;
};

// 🔐 Reset Password
export const resetPassword = async (token, password) => {
  const res = await api.post(`/auth/reset-password/${token}`, { password });
  return res.data;
};
